import { API_BASE_URL, getUploadedImageUrl } from '../../../../api';
import React, { useState, useEffect,useContext } from 'react';
import maleHolder from '../../../../assets/SVG/user.svg';
import femaleHolder from '../../../../assets/SVG/femaleUser.svg';
import { AccountContext } from '../../../../Contexts/main.context';

const ManageUsers = () => {
  const [userAccounts, setUserAccounts] = useState([]);
  const [allUsers, setAllUsers] = useState([]); // ← original unfiltered list
  const [activeFilter, setActiveFilter] = useState(null); // ← 'Admin', 'Manager', or null
  const {updateActiveOutlet,updateUserEditAccount} = useContext(AccountContext)

  useEffect(() => {
    const fetchUsers = async () => {
      const updatedClient = { script: "getUsers" };
      try {
        const response = await fetch(API_BASE_URL + 'data.php', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(updatedClient),
        });

        const data = await response.json();
        setUserAccounts(data);
        setAllUsers(data); // Save original list
      } catch (error) {
        alert("An error occurred getting users");
      }
    };

    fetchUsers();
  }, []);

  const handleFilter = (role) => {
    if (activeFilter === role) {
      // Toggle off filter
      setUserAccounts(allUsers);
      setActiveFilter(null);
    } else {
      // Apply filter
      setUserAccounts(allUsers.filter(user => user.accountSecurity === role));
      setActiveFilter(role);
    }
  };

  const createNewUser = () => {
     
     updateActiveOutlet('createUser');
  }

  const updateUserAccount = (user) => {
     updateUserEditAccount(user);
     updateActiveOutlet('updateUser');
  }

  return (
    <div className="col-46 offset-1 mt-4">
      <h3 className='text-center'>Manage Users</h3>

      {/* Filter Buttons */}
      <div className="col-46 offset-1 d-flex">
        <div className="ms-auto d-flex gap-2 align-items-center p-2 pe-4">
          <div>Filter By</div>
          <div
            className={`btn ${activeFilter === 'Admin' ? 'btn-warning' : 'btn-success'} text-light`}
            onClick={() => handleFilter('Admin')}
          >
            Admin
          </div>
          <div
            className={`btn ${activeFilter === 'Manager' ? 'btn-warning' : 'btn-primary'} text-light`}
            onClick={() => handleFilter('Manager')}
          >
            Manager
          </div>
        </div>
      </div>

     {/* User Cards */}
          <div className="d-flex gap-2 flex-wrap justify-content-center">
            {userAccounts.map((user, index) => (
              <div className="col-md-11 mb-3" key={index}>
               <div className="card border-solid border-2 border-secondary p-3">
                 <div className="d-flex justify-content-center">
                   <img
                    src={user.myPicture ? getUploadedImageUrl(user.myPicture) : user.iconSex === 'Female' ? femaleHolder : maleHolder}
                    className="rounded-circle flex-shrink-0"
                    alt={`${user.displayName}'s profile`}
                    style={{
                        width: "100px",
                        height: "100px",
                        minHeight: "100px",
                        maxHeight: "100px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: "2px solid gray",
                    }}
                   />
                 </div>
                 <div className="card-body">
                   <h5 className="card-title text-center">{user.displayName}</h5>
                   <div className="text-center fs-7">Phone : {user.phone || 'Not Set'}</div>
                   <div className="text-center fs-7 pb-2">Email : {user.email || 'Not Set'}</div>
                   <div className="card-text text-center border-top pt-3 border-navy">
                    <div className={`col-48 p-2 user-pill ${user.accountSecurity === 'Admin' ? 'bg-success text-light fw-bold' :
                      user.accountSecurity === 'Manager' ? 'bg-primary text-light fw-bold' : 'bg-danger text-light fw-bold'}`}
                      onClick={() =>updateUserAccount(user)}> 
                      {user.accountSecurity}
                    </div>
                   </div>
                 </div>
               </div>
              </div>
            ))}

            {/* Add New User Card */}
        <div className="col-md-11 mb-3">
          <div className="card border-solid alert-success border-2 border-secondary p-3">
            <img
              src={maleHolder}
              className="rounded-circle flex-shrink-0"
              alt="New User's profile"
              style={{
                width: '100px',
                height: '100px',
                minHeight: '100px',
                maxHeight: '100px',
                borderRadius: '50%',
                objectFit: 'cover',
                margin: '0 auto',
                display: 'block'
              }}
            />
            <div className="card-body">
              <h5 className="card-title text-center pb-2">New User</h5>
              <div className="text-center fs-7">Phone : Not Required</div>
              <div className="text-center fs-7 pb-2 text-danger">Email : Required</div>
              <div className="card-text text-center border-top pt-2 border-navy">
                <div className="col-48 p-2 user-pill text-light bg-warning" onClick={()=>createNewUser()}>New User</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageUsers;
